import { EPaymentFrequency, EWorksheetStatus } from '@if/core/types'
import { formatDate } from '@if/core/utils'
import * as yup from '@if/core/yup'
import { Vehicle, VehicleSchema } from './AutoWorksheetSchema'
import { IFinanceBaseWorksheet } from './IFinanceBaseWorksheetSchema'
import { SUPPORTED_PAYMENT_FREQUENCIES } from './constants'

export type CreditRslaWorksheet = IFinanceBaseWorksheet & {
  id: string
  internalType: string
  vehicle: Vehicle
  lienAmountFee: number
  brokerAdminFee: number
  roadsideAssistanceAmount: number
  merchantReferralFee: number
  paymentAmountForFrequency: number
  planName: string
}

export const EditCreditRslaWorksheetDtoSchema = yup.object({
  id: yup.string().default(''),
  vehicle: VehicleSchema,
  status: yup.mixed<EWorksheetStatus>().default(EWorksheetStatus.Draft),
  amountRequested: yup.double().positive(),
  deliveryOn: yup.string().default('').required(),
  firstPaymentOn: yup.string().dateOnly().default(formatDate(new Date())).nullable().required(),
  paymentFrequency: yup.mixed<EPaymentFrequency>().required().oneOf(SUPPORTED_PAYMENT_FREQUENCIES),
  paymentAmountForFrequency: yup.double().positive().required().default(0),
  term: yup.integer().min(12).required(),
  lienAmountFee: yup.double().min(0),
  brokerAdminFee: yup.double().min(0),
  roadsideAssistanceAmount: yup.double().min(0),
  merchantReferralFee: yup.double().min(0),
  insuranceFee: yup.double().min(0),
  creditApplicationId: yup.string().nullable(),
  versionTag: yup.string(),
  planName: yup.string().default(''),
  lenderFee: yup.double().min(0),
})
export type EditCreditRslaWorksheetDto = yup.InferSubmit<typeof EditCreditRslaWorksheetDtoSchema>
